/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import AppointmentTime from './AppointmentTime/index'
import Chair from './Chair/index'
import Color from './Color/index'
import Name from './Name/index'
import Profile from './Profile/index'
import Provider from './Provider/index'
import React from 'react'
import ScheduleTime from './ScheduleTime/index'
import State from './State/index'
import Type from './Type/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  onMouseEnterManual,
  onMouseLeaveManual,
  hovered
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let appointmentBookingItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking_item',
path: 'isFirst',
})
let appointmentBookingProviderCallValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_booking',
path: 'provider_call',
format: fromHelpers.isUrgent,
})
let appointmentBookingProviderCallValueData1 = fromData.useDataFormat({ viewPath,
context: 'appointment_booking',
path: 'provider_call',
format: fromHelpers.isDoctorCalled,
})
let appointmentBookingDisabledValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'disabled',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsRed100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.100'
        })
let dtColorsGreen100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  isHoveredManual,
  onMouseEnterManual,
  onMouseLeaveManual,
  hovered
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--pt-2-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-5-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-1-dUIJ5': appointmentBookingItemIsFirstValueData ? "0px" : "4px",'--bc-6-dUIJ5': appointmentBookingProviderCallValueData ? dtColorsRed100 : appointmentBookingProviderCallValueData1 ? dtColorsGreen100 : isHoveredManual ? dtColorsGreen100 : dtColorsWhite,'--o-7-dUIJ5': appointmentBookingDisabledValueData ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal}`}
>
<Color
  viewPath={`${viewPath}/Color`}
/>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Profile
  viewPath={`${viewPath}/Profile`}
/>
</div>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Appointment.Horizontal:3"
  data-view-path={viewPath}
 style={{'--h-8-dUIJ5': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="Appointment.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<State
  viewPath={`${viewPath}/State`}
/>
<ScheduleTime
  viewPath={`${viewPath}/ScheduleTime`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
<div
  data-testid="Appointment.Horizontal:6"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnterManual}
 onMouseLeave={onMouseLeaveManual}
 className={`views-block ${styles.Horizontal6}`}
>
<Name
  viewPath={`${viewPath}/Name`}
 hovered={hovered}
/>
</div>
<div
  data-testid="Appointment.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<Chair
  viewPath={`${viewPath}/Chair`}
/>
<div
  data-testid="Appointment.Horizontal:7"
  data-view-path={viewPath}
 style={{'--mt-1-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-9-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal7}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<AppointmentTime
  viewPath={`${viewPath}/AppointmentTime`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:8"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal8}`}
>
<Provider
  viewPath={`${viewPath}/Provider`}
/>
</div>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}